module.exports = __webpack_public_path__ + "img/slider1.15365080.jpg";